<div class="custom-place">
  <div class="text-sm text-600 mb-3">
    {{ editing ? 'A place added by hand.' : 'A place that isn\'t in the crawl, added by hand in ' + (suburbName || 'this suburb') + '.' }}
    Type its details; nothing is taken from Google.
  </div>

  <div class="grid formgrid">
    <div class="field col-12">
      <label class="text-600 text-sm" for="cp-name">Name</label>
      <input id="cp-name" pInputText type="text" class="w-full" [(ngModel)]="form.name" maxlength="200" placeholder="St Jude's Church Hall" />
    </div>
    <div class="field col-12">
      <label class="text-600 text-sm">Type</label>
      <p-dropdown [options]="kinds" [(ngModel)]="form.kind" optionLabel="label" optionValue="value" placeholder="Choose a type"
                  styleClass="w-full custom-kind" appendTo="body" [filter]="true" filterBy="label"></p-dropdown>
    </div>
    <div class="field col-12">
      <label class="text-600 text-sm">Pin</label>
      <div class="pin-line">
        <i class="pi pi-map-marker"></i>
        <span *ngIf="pin; else noPin">{{ pin.lat | number: '1.5-5' }}, {{ pin.lng | number: '1.5-5' }}</span>
        <ng-template #noPin><span class="text-600">not placed yet</span></ng-template>
      </div>
      <small class="block text-500 mt-1">Click the map where the place is: the amber pin moves there. Zoom in for accuracy.</small>
    </div>
    <div class="field col-8">
      <label class="text-600 text-sm" for="cp-street">Street address <span class="text-500">(optional)</span></label>
      <input id="cp-street" pInputText type="text" class="w-full" [(ngModel)]="form.street" maxlength="120" placeholder="12 Avoca Street" />
    </div>
    <div class="field col-4">
      <label class="text-600 text-sm" for="cp-postcode">Postcode</label>
      <input id="cp-postcode" pInputText type="text" class="w-full" [(ngModel)]="form.postcode" maxlength="4" placeholder="2031" />
    </div>
    <div class="field col-12">
      <label class="text-600 text-sm" for="cp-website">Website <span class="text-500">(optional)</span></label>
      <input id="cp-website" pInputText type="url" class="w-full" [(ngModel)]="form.website" maxlength="500" placeholder="https://" />
    </div>
    <div class="field col-12">
      <label class="text-600 text-sm" for="cp-phone">Phone <span class="text-500">(optional)</span></label>
      <input id="cp-phone" pInputText type="tel" class="w-full" [(ngModel)]="form.phone" maxlength="40" />
    </div>
  </div>

  <div *ngIf="error" class="err mb-2">{{ error }}</div>
  <div class="flex flex-wrap gap-2 align-items-center">
    <button pButton type="button" class="custom-save" [label]="editing ? 'Save' : 'Add the place'" icon="pi pi-check" (click)="save()" [disabled]="!canSave" [loading]="busy"></button>
    <button pButton type="button" class="p-button-text" label="Cancel" (click)="cancelled.emit()" [disabled]="busy"></button>
    <span class="flex-1"></span>
    <button *ngIf="editing" pButton type="button" class="p-button-text p-button-danger custom-delete" icon="pi pi-trash" label="Delete"
            (click)="remove()" [disabled]="busy || !!deleteBlockedBy" [pTooltip]="deleteBlockedBy || ''"></button>
  </div>
  <div *ngIf="editing && deleteBlockedBy" class="text-500 text-sm mt-1">{{ deleteBlockedBy }}</div>
</div>
